import React from 'react';
import { AppBar, Toolbar, Typography, Button, IconButton, Box } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';

const AppBarComponent = ({ toggleSidebar }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    // Optional: Logout confirmation dialog here
    Cookies.remove('auth_token');
    navigate('/login');
  };

  return (
    <AppBar position="static" sx={{ backgroundColor: '#E67E22' }}> {/* Muted Orange */}
      <Toolbar>
        <IconButton
          edge="start"
          color="inherit"
          aria-label="menu"
          onClick={toggleSidebar}
        >
          <MenuIcon />
        </IconButton>
        <Box sx={{ flexGrow: 1 }}>
          <Typography variant="h6">
            Case Register
          </Typography>
        </Box>
        <Button color="inherit" onClick={handleLogout}>Logout</Button>
      </Toolbar>
    </AppBar>
  );
};

export default AppBarComponent;
